module.exports = __webpack_public_path__ + "static/media/document-pdf.ebe02e38.svg";